import { Button, Icon } from "@nabble/ui";
import { useState } from "react";
import { RemoveTotpDialog } from "./RemoveTotpDialog";
import { SetUpTotpDialog } from "./SetUpTotpDialog";

/** Second factor → Authenticator app: whether it's set up, and the action to set it up or remove it. */
export function AuthenticatorAppRow({ enabled, onChanged }: { enabled: boolean; onChanged: () => void }): React.JSX.Element {
  const [setUpOpen, setSetUpOpen] = useState(false);
  const [removeOpen, setRemoveOpen] = useState(false);

  return (
    <>
      <div className="nb-setting-row">
        <div>
          <div className="nb-setting-title">Authenticator app</div>
          <p className="nb-setting-desc">6-digit codes from an app like Google Authenticator or 1Password.</p>
        </div>
        <div className="nb-setting-content">
          <div className="nb-row-between">
            {enabled ? (
              <span className="nb-status-line is-ok">
                <Icon name="checkCircle" />
                Set up
              </span>
            ) : (
              <span className="nb-status-line is-off">
                <Icon name="circle" />
                Not set up
              </span>
            )}
            {enabled ? (
              <Button label="Remove" variant="danger-soft" size="sm" icon="trash" onClick={() => setRemoveOpen(true)} />
            ) : (
              <Button label="Set up" variant="secondary" size="sm" icon="smartphone" onClick={() => setSetUpOpen(true)} />
            )}
          </div>
        </div>
      </div>

      {setUpOpen ? (
        <SetUpTotpDialog
          onClose={() => setSetUpOpen(false)}
          onDone={() => {
            setSetUpOpen(false);
            onChanged();
          }}
        />
      ) : null}

      <RemoveTotpDialog
        open={removeOpen}
        onClose={() => setRemoveOpen(false)}
        onRemoved={() => {
          setRemoveOpen(false);
          onChanged();
        }}
      />
    </>
  );
}
